import { render } from "./RecruitContactPage.vue?vue&type=template&id=2d3f07ec&scoped=true"
import script from "./RecruitContactPage.vue?vue&type=script&lang=js"
export * from "./RecruitContactPage.vue?vue&type=script&lang=js"

import "./RecruitContactPage.vue?vue&type=style&index=0&id=2d3f07ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3f07ec"]])

export default __exports__